import { AuthTypeAction, ReduxAction } from "redux/model";

export interface AuthAppReducer {
    authError?: string;
}

const initState: AuthAppReducer = {
    authError: "",
};

export const LOGIN_ERROR_MESSAGES = {
    "auth/user-not-found": "Email e/ou senha incorretos!",
    "auth/wrong-password": "Email e/ou senha incorretos!",
    "auth/weak-password": "A senha deve conter 6 caracteres ou mais",
    "auth/invalid-action-code":
        "Link já utilizado ou expirado. Por favor solicite um novo link para redefinição de senha em esqueci minha senha!",
    "auth/email-already-in-use":
        "Já existe uma conta com este email cadastrada!",
    "auth/email-already-exists":
        "Já existe uma conta com este email cadastrada!",
    "permission-denied": "Sem permissão para realizar esta operação!",
    "auth/invalid-email": "Email inválido!",
};

const authAppReducer = (state = initState, action: ReduxAction) => {
    switch (action.type) {
        case AuthTypeAction.CLEAN_AUTH_ERROR:
            return {
                ...state,
                authError: "",
            };
        case AuthTypeAction.LOGIN_ERROR:
            return {
                ...state,
                authError:
                    LOGIN_ERROR_MESSAGES[action.data.code] ||
                    action.data.message,
            };
        case AuthTypeAction.LOGIN_SUCCESS:
            return {
                ...state,
                authError: "",
            };
        case AuthTypeAction.SIGN_UP_ERROR:
            return {
                ...state,
                authError:
                    LOGIN_ERROR_MESSAGES[action.data.code] ||
                    action.data.message,
            };
        case AuthTypeAction.SIGN_UP_SUCCESS:
            return {
                ...state,
                authError: "",
            };
        case AuthTypeAction.SIGN_OUT_SUCCESS:
            return {
                ...state,
            };
        default:
            return state;
    }
};

export default authAppReducer;
